import React, { useCallback, useMemo } from 'react'
import ReactSelect, { components } from 'react-select'
import Creatable from 'react-select/creatable'
import ReactAsyncSelect from 'react-select/async'

import CustomIcon from 'shared/components/customIcon'
import { stylesFn, InlineOptionContainer } from './styles'

/* eslint-disable react/display-name, react/prop-types */
const IconOption = (optProp) => (
  <components.Option {...optProp}>
    <InlineOptionContainer>
      <CustomIcon icon={optProp.data.id} />
      <span>{optProp.children}</span>
    </InlineOptionContainer>
  </components.Option>
)

const IconSingleValue = (optProp) => (
  <components.SingleValue {...optProp}>
    <InlineOptionContainer>
      <CustomIcon icon={optProp.data.id} isActive />
      <span>{optProp.children}</span>
    </InlineOptionContainer>
  </components.SingleValue>
)

const selectRenderer =
  (Component) =>
  ({
    id,
    className,
    disabled,
    readOnly,
    simpleValue,
    value,
    autoComplete,
    placeholder = '',
    onChange,
    onBlur,
    fluid,
    showError,
    underlined,
    styles,
    iconOptioned,
    size,
    bordered = false,
    ...props
  }) => {
    const menuPortalTarget =
      props.menuPortalTarget ||
      (typeof document === 'undefined' ? undefined : document.body)

    const onChangeCallback = useCallback(
      (value) => {
        return onChange({
          target: { value },
        })
      },
      [onChange]
    )

    const customStyles = useMemo(
      () =>
        stylesFn({
          disabled,
          fluid,
          showError,
          underlined,
          styles,
          value,
          size,
          bordered,
        }),
      [disabled, fluid, showError, underlined, styles, size]
    )

    const customComponents = useMemo(
      () => ({
        IndicatorSeparator: null,
        ...(iconOptioned
          ? { Option: IconOption, SingleValue: IconSingleValue }
          : {}),
      }),
      [iconOptioned]
    )

    return (
      <Component
        placeholder={placeholder}
        styles={customStyles}
        {...props}
        menuPortalTarget={menuPortalTarget}
        menuPosition={props.menuPosition || 'fixed'}
        isDisabled={disabled}
        className={className}
        value={value}
        onBlur={onBlur}
        onChange={onChangeCallback}
        components={customComponents}
      />
    )
  }

export const Select = selectRenderer(ReactSelect)
export const AsyncSelect = selectRenderer(ReactAsyncSelect)
export const Tags = selectRenderer(Creatable)
/* eslint-enable react/display-name, react/prop-types */
